import { connect } from 'react-redux';
import { getBundle } from 'app/dux/cmx/actions';
import App from './App';

const mapDispatchToProps = { getBundle };

// This exists to satisfy the type checker.
const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
